export const cookies = {
label: 'LEGAL',
title: 'Cookie Policy',
last_updated: 'Last Updated: January 2024',
intro: 'This Cookie Policy explains how One More Global Inc. uses cookies and similar technologies on our website.',
what_title: 'What Are Cookies',
what_text: 'Cookies are small data files that are placed on your device when you visit a website. They are widely used to make websites work more efficiently and to provide reporting information.',
types_title: 'Types of Cookies We Use',
essential: 'Essential Cookies',
essential_text: 'Required for the operation of our website. They enable basic functions like page navigation and language preference storage.',
analytics: 'Analytics Cookies',
analytics_text: 'Help us understand how visitors interact with our website by collecting and reporting information anonymously.',
manage_title: 'Managing Cookies',
manage_text: 'You can set your browser to refuse cookies or alert you when cookies are being sent. However, some parts of our website may not function properly without cookies.',
contact_title: 'Contact Us',
contact_text: 'If you have questions about our use of cookies, please contact us at our corporate office.',
};
